// import { Button } from '@mui/material';
import styled from 'styled-components';
import {SecondaryBtn} from '../../../components/UI/Button/StyledButton'
import Button from '../../../components/UI/Button/Button'
export const Breadcrumbs = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
`;

export const DeleteBtn = styled.button`
    color: #fb2629;
    border: 1px solid #fb2629;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
`;